<div class="cw__container is-fullwidth">
  <div class="cw__container__col">
    <div class="single-brand">
      <p class="cw_contact_heading" tabindex="0">Dedicated Sales Support</p>
      <h1 class="cw_contact_headline" role="heading" aria-level="1" tabindex="0">Contact Your Wholesaler</h1>
      <p class="cw_contact_body" tabindex="0">
        {{
          wholesalersDataObject?.wholeSalerPageText ||
            'Your wholesaling team is here to help. Contact your wholesaler directly or call the TruStage™ Annuities
        Solutions Desk at 877.345.GROW (4769). Calls will be answered between 7:30 AM and 6:00 PM CT.'
        }}
      </p>
      <ul class="wholesaler-list" role="list">
        <li *ngFor="let wholesaler of wholesalersData" class="wholesaler-item">
          <div class="wholesaler-info">
            <h3 class="wholesaler-name">{{ wholesaler.firstName }} {{ wholesaler.lastName }}</h3>
            <p class="wholesaler-phone">
              <a [href]="'tel:' + wholesaler.phoneNumber" class="phone-link">{{ wholesaler.phoneNumber }}</a>
            </p>
            <div class="wholesaler-email-wrapper">
              <a [href]="'mailto:' + wholesaler.emailAddress" class="wholesaler-email">{{ wholesaler.emailAddress }}</a>
              <div class="email-underline" aria-hidden="true"></div>
            </div>
          </div>
        </li>
      </ul>
    </div>
  </div>
  <div class="cw_contact_Image">
    <img src="../../../assets/images/Annuities-GrowWithInsight_Image.png" alt="" />
  </div>
</div>
